import { useQuery } from "react-query";
import { getAllDevices, getDeviceDetail } from "frontend/src/api/devices";
import { cacheKey } from "./shared";
export var useDevices = function () {
    return useQuery([cacheKey], getAllDevices);
};
export var useDevice = function (id) {
    return useQuery([cacheKey, id], function () { return getDeviceDetail(id); });
};
